module.exports = __webpack_public_path__ + "static/media/title.a079f841.png";